module.exports = __webpack_public_path__ + "img/dt.3aea2d64.png";